import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    movimento: null,
    saved: false
  },
  getters: {
    movimento: state => state.movimento,
    saved: state => state.saved
  },
  mutations: {
    SET_MOVIMENTO (state, payload) {
      state.movimento = payload
    },
    CLEAR_MOVIMENTO (state) {
      state.movimento = null
    },
    SET_MOVIMENTO_SAVED (state) {
      state.saved = true
    },
    CLEAR_MOVIMENTO_SAVED (state) {
      state.saved = false
    }
  },
  actions: {
  }
}
